import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';

type RequestErrorModalProps = {
  open: boolean;
  onClose: () => void;
};

const Content = () => {
  return (
    <TextV2 component="p">
      <Trans
        i18nKey="ui.event-management.generic.error-modal.content"
        components={{
          bold: <TextV2 component="span" variant="bodyBold" color="primary" />,
        }}
      />
    </TextV2>
  );
};

const RequestErrorModal = ({ open, onClose }: RequestErrorModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      title={t('ui.event-management.generic.error-modal.title')}
      secondaryButtonText={t(
        'ui.event-management.generic.error-modal.confirm-button',
      )}
      content={<Content />}
      onClose={onClose}
    />
  );
};

export default RequestErrorModal;
